import {Component, DestroyRef, inject, OnInit,} from '@angular/core';
import {BokkzIbDataService, IbRekenService, IncomeTaxEntity} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, filter, Observable, shareReplay, take} from 'rxjs';
import {FormControl, FormGroup,} from '@angular/forms';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector:
    'snelstart-venture-fiscaal-feature-box1-belastbare-inkomsten-uit-eigenwoning',
  templateUrl: './box1-belastbare-inkomsten-uit-eigenwoning.component.html',
  styleUrls: ['./box1-belastbare-inkomsten-uit-eigenwoning.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class Box1BelastbareInkomstenUitEigenwoningComponent implements OnInit {

  private dataService = inject(BokkzIbDataService);
  private destroyRef = inject(DestroyRef);
  private bokkzClient = inject(IbRekenService);
  public dataVisible$ = new BehaviorSubject<boolean>(false);

  readonly incomeTaxEntity$: Observable<IncomeTaxEntity> =
    this.dataService.incomeTaxEntity$.pipe(
      filter((data): data is IncomeTaxEntity => !!data?.sstRelationId),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );

  public formGroup = new FormGroup({
    eigenWoningForfait: new FormControl<number | null>(0),
    belastDeelKapitaalverzekering: new FormControl<number | null>(0),
    eigenWoningRente: new FormControl<number | null>(0),
    erfpachtcanon: new FormControl<number | null>(0),
    personeelsvoordeel: new FormControl<number | null>(0),
    kostenEigenWoningSchuld: new FormControl<number | null>(0),
    renteRestschuldEigenWoning: new FormControl<number | null>(0),
    kostenRestschuldEigenWoning: new FormControl<number | null>(0),
    huurinkomstenEW: new FormControl<number | null>(0),
    aandeelInVoordeelEigenWoning: new FormControl<number | null>(0),
    aandeelInRenteEnKostenEigenWoning: new FormControl<number | null>(0),
    aandeelInSaldoEigenWoning: new FormControl<number | null>(0),
    saldoEigenWoning: new FormControl<number | null>(0),
    aftrekWegensGeenOfGeringeEigenWoningSchuld: new FormControl<number | null>(0),
  });

  ngOnInit(): void {
    this.incomeTaxEntity$.pipe(
      take(1),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.bokkzClient.getIncomeTaxReport(this.dataService.incomeTaxEntity.value.aangifte!).subscribe(details => {
        this.formGroup.reset({}, {emitEvent: false});
        this.formGroup.patchValue(details.specificatieEW?.opbouw ?? {}, {emitEvent: false});
        this.formGroup.patchValue({saldoEigenWoning : details.specificatieInkomenBox1?.opbouw?.saldoEigenWoning }, {emitEvent: false});
        this.formGroup.patchValue({aftrekWegensGeenOfGeringeEigenWoningSchuld : details.specificatieInkomenBox1?.opbouw?.aftrekWegensGeenOfGeringeEigenWoningSchuld }, {emitEvent: false});
        this.formGroup.disable({emitEvent: false});
        this.dataVisible$.next(true);
      });
    });
  }
}
